import React from "react";
import logo from "../../data/logo/logo-black.svg";
import "./Logo.scss";

export default function Logo() {
    return <img className="logo" src={logo} alt="large M symbol" />
}